$(window).load(function () {
});
$(document).ready(function () {
    /*tłumaczenie date pickera*/
    $.datepicker.setDefaults($.datepicker.regional['pl']);

    /*Obsługa formularza do zakupu biletu */
    $ticketName = $("#buy-ticket-name");
    $ticketDate = $("#buy-ticket-date");
    $ticketHour = $("#buy-ticket-hour");
    $ticketDatesList = $("#moviedates");
//jsonEvents - json z informacjami o eventach
    /*Zmiana filmu - reset pól data i godzina*/
    $ticketName.on("change", function () {
        $("#datepicker").datepicker({beforeShowDay: restrictDates, dateFormat: "yy-mm-dd"});
        $ticketDatesList.find("option").remove();
        $ticketHour.find("option").remove();
        $ticketDate.val("");
        $ticketHour.val("");
        $("#datepicker").val("");
        var exisiting = [];
        jsonEvents[$ticketName.val()]['info'].forEach(function (item, index) {
            if (exisiting.indexOf(item['day']) == -1) {
                option = $("<option>" + item['day'] + "</option>");
                exisiting.push(item['day']);
                $ticketDatesList.append(option);
            }
        });

    });
    /*Zmiana daty - zmiana godzin html 5*/
    $ticketDate.on("change", function () {
        $ticketHour.find("option").remove();
        jsonEvents[$ticketName.val()]['info'].forEach(function (item, index) {

            if ($ticketDate.val() == item['day']) {
                option = $("<option value='" + item['event_id'] + "'>" + item['time'] + "</option>");
                $ticketHour.append(option);

            }
        });
        generateLinksToTickets();
    });

    /*Zmiana nazwy jquery ui*/
    function restrictDates(d) {

        movieName = $ticketName.val();
        flag = false;
        sCompareDate = "";
        sCompareDate += d.getFullYear();
        sCompareDate += "-";
        sCompareDate += ((d.getUTCMonth() + 1 < 10) ? "0" : "") + (d.getUTCMonth() + 1);
        sCompareDate += "-";
        sCompareDate += ((d.getUTCDate() + 1 < 10) ? "0" : "") + (d.getUTCDate() + 1);

        jsonEvents[movieName]['info'].forEach(function (item, index) {

            if (sCompareDate == item['day']) {
                flag = true;
            }
        });
        if (flag) {

            return [true, "", ""];
        }
        else {
            return [false, "", ""];
        }
    }

    $("#datepicker").datepicker({beforeShowDay: restrictDates, dateFormat: "yy-mm-dd"});

    $("#datepicker").on("change", function () {
        $ticketHour.find("option").remove();
        var counter = 0;
        jsonEvents[$ticketName.val()]['info'].forEach(function (item, index) {
            if ($("#datepicker").val() == item['day']) {
                option = $("<option value='" + item['event_id'] + "'>" + item['time'] + "</option>");
                $ticketHour.append(option);
                if (counter == 0) {
                    current = option;
                }
                counter++;
            }
        });


        generateLinksToTickets();
    });


    /*Zmiana godziny - zmiana linkow*/
    $ticketHour.on("change", function () {
        generateLinksToTickets();
    });
    /*Obsługa Ajaxowa dla repertuaru*/
    if ($("#ajax-container-schedule")) {
        showTodaySchedule();
    }
    var $dayButtons = $(".ajax-button-schedule");
    $dayButtons.each(function () {
        $(this).on("click", function () {
            $(".ajax-button-schedule.active").removeClass("active");
            $(this).addClass("active");
            var sDate = $(this).data("day");
            if (typeof sCurrentSchedule == "undefined") {
                sCurrentSchedule = sDate;


                $.post({
                        url: window.location.href,
                        data: {day: sDate},
                        success: function (response) {
                            $("#ajax-container-schedule").html(response);
                            refreshSchedule();
                        }
                    }
                );
            }
            else if (typeof sCurrentSchedule != "undefined") {
                if (sCurrentSchedule != sDate) {
                    sCurrentSchedule = sDate;


                    $.post({
                            url: window.location.href,
                            data: {day: sDate},
                            success: function (response) {
                                $("#ajax-container-schedule").html(response);
                                refreshSchedule();
                            }
                        }
                    );
                }
            }

        });
    });
});

function generateLinksToTickets() {
    //Przykładowy poprawny link (ten w dokumentacji API jest niepoprawny
    //http://185.62.180.104/Msi/default.aspx?event_id=34528&typetran=0&returnlink=http://www.planetcinema.pl/elk/
    //$obj = jsonEvents[$ticketName.val()]['info'].find(x => x.event_id === $ticketHour.val());
    $obj = $.grep(jsonEvents[$ticketName.val()]['info'], function (e) {
        return e.event_id == $ticketHour.val();
    })[0];
    console.log($obj);

    $("#buy-ticket-button").attr("href", scheduleUrl + "/Msi/default.aspx?typetran=0&event_id=" + $ticketHour.val() + "&returnlink=" + window.location);
    $("#buy-ticket-button").removeClass();
    $("#buy-ticket-button").addClass($obj['available_in_sale'] ? "active" : "not-active");
    $("#buy-ticket-button").attr("target", "_blank");
    $("#reserve-ticket-button").attr("target", "_blank");
    $("#reserve-ticket-button").attr("href", scheduleUrl + "/Msi/default.aspx?typetran=1&event_id=" + $ticketHour.val() + "&returnlink=" + window.location);
    $("#reserve-ticket-button").removeClass();
    $("#reserve-ticket-button").addClass($obj['available_in_book'] ? "active" : "not-active");
}

function showTodaySchedule() {
    $.post({
            url: window.location.href,
            data: {day: "today"},
            success: function (response) {
                $("#ajax-container-schedule").html(response);
                refreshSchedule();
            }
        }
    );
}

function refreshSchedule() {
    /*Obsługa hovera repertuar*/
    var $ticketLinks = $(".buy-ticket-hover");
    $ticketLinks.each(function () {
        $(this).on("mouseover", function () {

            $popup = $("#schedule-popup");
            $popup.addClass("visible");
            $popup.on("mouseleave", function () {
                $popup = $("#schedule-popup");
                $popup.removeClass("visible");
            });

            $popup.find(".date").html($(this).data("day") + ", godz. " + $(this).data("hours"));
            $popup.find(".title").html($(this).data("name"));
            $popup.find("#buy-popup").attr("href", scheduleUrl + "/Msi/default.aspx?typetran=0&event_id=" + $(this).data("event-id") + "&returnlink=" + window.location);
            $popup.find("#reserve-popup").attr("href", scheduleUrl + "/Msi/default.aspx?typetran=1&event_id=" + $(this).data("event-id") + "&returnlink=" + window.location);

            $popup.css({
                top: Math.floor($(this).position().top) - 60 + "px",
                left: Math.floor($(this).position().left) - 180 + "px"
            });
        });
    });
}